import Axios from "../../axios";
export function expiredInvitation(
  invitation_uuid_token: string | undefined
): Promise<any> {
  return Axios.get(`/v1/is_expired_token?token=${invitation_uuid_token}`);
}
export function resendInvitation(
  invitation_uuid_token: string | undefined,
  email: string
): Promise<any> {
  return Axios.post(`/v1/resend_invitation?token=${invitation_uuid_token}`, {
    email,
  });
}
